import styled from 'styled-components';
import { trackEvent } from 'lib/analytics';
import type { ContentImage } from 'lib/pdp-modules/types';

const CyclesContainer = styled.div`
  position: relative;
  margin: 1.5rem auto 0;
  border-radius: 100px;
  padding: 0.5rem;
  width: fit-content;
  display: flex;
  justify-content: center;
  background-color: var(--color-neutral-frosted-glass-t8);
`;

const CyclesButton = styled.button`
  position: relative;
  appearance: none;
  border: 0;
  padding: 0.625rem 1.125rem;
  width: 5.75rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  z-index: 2;
`;

const CyclesButtonOverlay = styled.span`
  position: absolute;
  top: 0.5rem;
  bottom: 0.5rem;
  left: 0;
  border-radius: 100px;
  width: 5.75rem;
  transform: translateX(0.5rem);
  background-color: white;
  transition: left 0.2s;
`;

type NutrientCyclesProps = {
  allCycles: Record<
    string,
    { label: string; icon?: ContentImage; cardIndex: number }
  >;
  selectedTile: number | null;
  goToNewVideo: (cardIndex: number) => void;
};

const NutrientCycles = ({
  allCycles,
  selectedTile,
  goToNewVideo,
}: NutrientCyclesProps) => {
  const hasTileSelection = selectedTile !== null && selectedTile !== undefined;
  const maxMinSelectedIndex = hasTileSelection
    ? Math.max(0, Math.min(selectedTile, Object.values(allCycles).length - 1))
    : 0;
  return (
    <CyclesContainer>
      {Object.values(allCycles).map((cycle, cycleIndex) => (
        <CyclesButton
          key={`nutrient-cycle-${cycle.label}`}
          onClick={() => {
            goToNewVideo(cycle.cardIndex);
            trackEvent('Button Clicked', {
              buttonName: 'Day/Night selector: ' + cycle.label,
              location: 'PDP',
            });
          }}
          cycle-selected={cycleIndex === selectedTile ? 'selected' : ''}
        >
          <img src={cycle.icon?.url} alt={`Icon for ${cycle.label} cycle`} />
          <span>{cycle.label}</span>
        </CyclesButton>
      ))}
      <CyclesButtonOverlay
        style={{
          opacity: hasTileSelection ? 1 : 0,
          left: `calc(5.75rem * ${maxMinSelectedIndex})`,
        }}
      />
    </CyclesContainer>
  );
};

export default NutrientCycles;
